import PropTypes from 'prop-types';
// @flow

import React from 'react';
import _ from 'lodash';

import { NumberInput } from 'PMT/components/form';

import I18n from 'PMT/i18n/I18n';

import { Config } from 'constants';

import { Restaurant } from 'PMT/entities';
import { OrderSettings } from 'PMT/entities/order';
import { SecurityContext } from 'utils';

//
// components
//
import AbstractOrderSettingsForm from './AbstractOrderSettingsForm';
import Switch from 'react-bootstrap-switch';
import OrderNotificationSettingsView from './OrderNotificationSettingsView';

import { Form } from 'react-bootstrap';
import FormGroupView from 'PMT/components/form/FormGroupView';

export default class OrderGeneralSettingsPage extends AbstractOrderSettingsForm {

  static propTypes = {
    restaurant: PropTypes.objectOf(Restaurant),

    orderSettings: PropTypes.objectOf(OrderSettings),

    onSubmit: PropTypes.func.isRequired
  };

  state = this.getDefaultState(this.props.orderSettings);

  //
  //
  //

  onChangeOrderSettings = (orderSettings: OrderSettings) => {
    this.setState({
      orderSettings
    });
  };

  onOnSiteEnabledChange = () => {
    const orderSettings:OrderSettings = this.orderSettings;
    orderSettings.onSiteSettings.enabled = !orderSettings.onSiteSettings.enabled;
    this.onChangeOrderSettings(orderSettings);
  };

  onTakeAwayEnabledChange = () => {
    const orderSettings:OrderSettings = this.orderSettings;
    orderSettings.takeAwaySettings.enabled = !orderSettings.takeAwaySettings.enabled;
    this.onChangeOrderSettings(orderSettings);
  };

  onDeliveryEnabledChange = () => {
    const orderSettings:OrderSettings = this.orderSettings;
    orderSettings.deliverySettings.enabled = !orderSettings.deliverySettings.enabled;
    this.onChangeOrderSettings(orderSettings);
  };

  onMenuManagedByPosChange = () => {
    const orderSettings: OrderSettings = this.orderSettings;
    orderSettings.menuManagedByPos = !orderSettings.menuManagedByPos;
    this.onChangeOrderSettings(orderSettings);
  }


  //
  // Renderers
  //

  renderGeneral() {
    return (
      <div className="top-buffer-50">

      </div>
    );
  }

  renderOnSite() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.general.on_site')}
        </FormGroupView.Label>
        <FormGroupView.Content>
          <Switch
            bsSize="mini"
            value={this.orderSettings.onSiteSettings.enabled}
            onChange={this.onOnSiteEnabledChange}
            disabled={!this.canEditSettings()}
          />
        </FormGroupView.Content>
      </FormGroupView>
    );
  }

  renderTakeAway() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.general.take_away')}
        </FormGroupView.Label>
        <FormGroupView.Content>
          <Switch
            bsSize="mini"
            value={this.orderSettings.takeAwaySettings.enabled}
            onChange={this.onTakeAwayEnabledChange}
            disabled={!this.canEditSettings()}
          />
        </FormGroupView.Content>
      </FormGroupView>
    );
  }

  renderDelivery() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.general.delivery')}
        </FormGroupView.Label>
        <FormGroupView.Content>
          <Switch
            bsSize="mini"
            value={this.orderSettings.deliverySettings.enabled}
            onChange={this.onDeliveryEnabledChange}
            disabled={!this.canEditSettings()}
          />
        </FormGroupView.Content>
      </FormGroupView>
    );
  }

  renderModes() {
    return (
      <div>
        <h3>{I18n.tr('order.settings.general.order_modes')}</h3>

        {this.renderOnSite()}
        {this.renderTakeAway()}
        {this.renderDelivery()}

        <div className="clear" />
        <hr />
      </div>
    );
  }

  renderNotificationsSettings() {
    return (
      <div className="top-buffer-50">
        <h3>{I18n.tr('order.settings.general.notifications')}</h3>

        <OrderNotificationSettingsView
          orderSettings={this.orderSettings}
          onChange={this.onChangeOrderSettings}
          readOnly={!this.canEditSettings()}
        />
      </div>
    );
  }

  renderMenuManagedByPos() {
    if (!SecurityContext.orderSettings.canEditMenuManagedByPos()) {
      return (null);
    }
    return (
      <div className="top-buffer-50">
        <h3>{I18n.tr('order.settings.general.menu_managed_by_pos')}</h3>

        <FormGroupView>
          <FormGroupView.Label>
            {I18n.tr('order.settings.general.menu_managed_by_pos')}
          </FormGroupView.Label>
          <FormGroupView.Content>
            <Switch
              bsSize="mini"
              value={this.orderSettings.menuManagedByPos}
              onChange={this.onMenuManagedByPosChange}
              // TODO:
              disabled={!SecurityContext.orderSettings.canEditMenuManagedByPos()}
            />
          </FormGroupView.Content>
        </FormGroupView>
      </div>
    );
  }

  renderBody() {
    return (
      <Form horizontal>
        {this.renderGeneral()}

        {this.renderModes()}
        
        {this.renderNotificationsSettings()}

        {this.renderMenuManagedByPos()}

        {this.renderFixedButtons()}
      </Form>
    );
  }

  render() {
    try {
    return (
      <div>
        {this.renderBody()}
      </div>
    );
  } catch (e) { console.error(e); }
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/order/settings/components/OrderGeneralSettingsPage.js